import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

function ManualDef4({ setTutorial }) {
  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      <div className={`${styles["foreground"]} ${styles["foreground-4"]} ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Great job! A function needs at least three parameters to work properly. Go ahead and
              add two more, and make sure to give them at least two choices.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualDef4;
